import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule, ChildrenOutletContexts } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NbLayoutModule } from '@nebular/theme';
import { tap } from 'rxjs';

import { TitleService, ReleaseService } from './core/services';
import { FooterComponent } from './components';
import { redirectMobileToStore } from './app.helpers';
import fadeAnimation from './app-animations';
import BASE from './app.base';

@Component({
  selector: 'sid-root',
  template: `
    <nb-layout>
      <nb-layout-column>
        <div [@routeAnimations]="getRouteAnimationData()" class="relative w-full h-dvh overflow-hidden bg-basic-1000">
          <router-outlet class="block" />
          <sid-footer />
        </div>
      </nb-layout-column>
    </nb-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbLayoutModule, RouterModule, FooterComponent],
  providers: [ReleaseService],
  animations: [fadeAnimation],
})
export default class AppComponent {
  private readonly contexts = inject(ChildrenOutletContexts);
  private readonly release = inject(ReleaseService);
  private readonly _ = inject(TitleService);

  constructor() {
    redirectMobileToStore();
    console.log('Senet ID Frontend:', BASE.version);
    this.release
      .getVersion()
      .pipe(
        tap((data) => console.log('Senet ID Backend:', data.version)),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  protected getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
}
